import { FormControl } from 'baseui/form-control'
import { HOPInput } from '@/shared/components/HOPComponents/HOPInput'

const FilterSales = ({ searchValue, setSearchValue, t }) => {
  return (
    <FormControl label={t('additionalSales:common.filter_sales_label')}>
      <HOPInput handleValue={value => setSearchValue(value)} currentValue={searchValue} />
    </FormControl>
  )
}

export default FilterSales
